import { Controller } from "@hotwired/stimulus"
import { getDeviceFingerprint } from "~/lib/device_fingerprint"

// Captures device fingerprint on the registration page and writes it to a cookie.
// The server reads this cookie during account creation to prevent welcome credit abuse.
// Works for both email signup (form POST) and OAuth (redirect survives via SameSite=Lax).
export default class extends Controller {
  connect(): void {
    this.captureFingerprint()
  }

  private async captureFingerprint(): Promise<void> {
    try {
      const fingerprint = await getDeviceFingerprint()
      if (fingerprint) {
        const expires = new Date(Date.now() + 60 * 60 * 1000).toUTCString()
        document.cookie = `signup_device_fingerprint=${encodeURIComponent(fingerprint)}; path=/; expires=${expires}; SameSite=Lax`
      }
    } catch {
      // Silent failure — server will withhold credit if no fingerprint is present.
    }
  }
}
